import { Skeleton } from '@chakra-ui/react';

export const Loading = () => {
  return [...Array(6)].map((_, i) => {
    return (
      <Skeleton
        key={i}
        h={{
          base: '215px',
          desktop: '144px',
        }}
        rounded="12px"
        bgColor="background.offWhite/80"
      />
    );
  });
};
